import React from "react";
const IconAppointment = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M7.5 2.5v4m5-4v4M3 9V4.5h14V9M3 9v8.5h14V9M3 9h14"
    />
  </svg>
);
export default IconAppointment;
